export const environment = {
  production: true,
  envName: 'pre',
  apiUrl: 'https://api-itracing-pre.comsatelsmart.com/backs/smart-tracing',
  notificacionUrl: 'wss://soa-pre.comsatel.com.pe/notificaciones-utility/canales',
  chatWebUrl: 'https://api-itracing-pre.comsatelsmart.com/backs/chat-interactivo',
  clienteUrl: 'http://itracing-pre.comsatelsmart.com/#/entrega',
  apiKeyHereMaps: 'wrJj3cNnDMTiphnw56uyOHV03ihkGlxnQEBst7PfDbo',
  apiKeyGoogleMaps: 'AIzaSyBkaKnB3OhZiJ2YCMH5jOkEKvbchwFxh24',
  apiKeyGoogleRecaptcha: '6LfWKPwUAAAAADDXJRFlQA-RaPVIBBRfi4v5P_D9',
  mapInitialPosition: { lat: -12.09918608864384, lng: -77.02581502497196 },
  webUrl: 'https://www.comsatel.com.pe/nosotros/acerca-de-comsatel/',
  logoConTexto: 'assets/images/comsatellogo.svg',
  terminosLegales: 'https://www.smart-tracing.com/terminos-y-condiciones/',
  politicasPrivacidad: 'https://www.smart-tracing.com/politica-de-privacidad/'
};
